/* MAISON DOPERA, Beyond the Game */
(function () {
  'use strict';

  var NAME_RE = /[^A-ZÀ-ÖØ-Ý' .-]/g;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var canAnim = 'IntersectionObserver' in window && !reduceMotion;
  if (canAnim) document.documentElement.classList.add('ofx-anim');

  /* ---------- Rideau d'ouverture : un clic le fait disparaître ---------- */
  var curtain = document.querySelector('[data-ofx-curtain]');
  var intro = !!curtain && !document.documentElement.classList.contains('ofx-no-intro');
  if (curtain) curtain.addEventListener('click', function () { curtain.classList.add('is-gone'); });

  /* ---------- En-tête aux couleurs du club visible dessous ---------- */
  var bar = document.querySelector('.ofx-bar');
  var hdrTargets = document.querySelectorAll('[data-ofx-hdr]');
  var hdrTick = 0;
  function hdrUpdate() {
    hdrTick = 0;
    if (!bar) return;
    var line = bar.getBoundingClientRect().bottom;
    var hit = null;
    for (var i = 0; i < hdrTargets.length && !hit; i++) {
      var r = hdrTargets[i].getBoundingClientRect();
      if (r.top <= line + 240 && r.bottom > line + 1) hit = hdrTargets[i];
    }
    var root = document.documentElement.style;
    if (hit) {
      var cs = getComputedStyle(hit);
      var bg = (cs.getPropertyValue('--hdr-bg') || cs.getPropertyValue('--bg')).trim();
      var fg = (cs.getPropertyValue('--hdr-fg') || cs.getPropertyValue('--fg')).trim();
      if (bg && fg) { root.setProperty('--bar-bg', bg); root.setProperty('--bar-fg', fg); return; }
    }
    root.removeProperty('--bar-bg');
    root.removeProperty('--bar-fg');
  }
  function hdrQueue() { if (!hdrTick) hdrTick = requestAnimationFrame(hdrUpdate); }
  if (bar && hdrTargets.length) {
    window.addEventListener('scroll', hdrQueue, { passive: true });
    window.addEventListener('resize', hdrQueue);
    hdrUpdate();
  }

  /* ---------- Menu plein écran ---------- */
  var overlay = document.querySelector('[data-ofx-overlay]');
  var openBtn = document.querySelector('[data-ofx-menu-open]');
  var lastFocus = null;
  function openMenu() {
    if (!overlay) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.body.classList.add('is-locked');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    var small = window.matchMedia('(max-width: 899px)').matches;
    var first = (small ? overlay.querySelector('[data-ofx-menu-close]') : overlay.querySelector('input[type="search"]')) || overlay.querySelector('a, button');
    if (first) first.focus({ preventScroll: true });
  }
  function closeMenu() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.body.classList.remove('is-locked');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (lastFocus) lastFocus.focus();
  }
  if (openBtn) openBtn.addEventListener('click', openMenu);
  document.querySelectorAll('[data-ofx-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
    if (e.key === 'Tab' && overlay && !overlay.hidden) {
      var items = overlay.querySelectorAll('a[href], button, input, summary, select');
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Sur mobile, championnats et continents se déplient au toucher ; sur grand écran, tout reste ouvert */
  var accMq = window.matchMedia('(max-width: 899px)');
  var accs = document.querySelectorAll('[data-ofx-acc]');
  function accSync() { accs.forEach(function (d) { d.open = !accMq.matches; }); }
  if (accs.length) {
    accSync();
    if (accMq.addEventListener) accMq.addEventListener('change', accSync);
    else if (accMq.addListener) accMq.addListener(accSync);
    accs.forEach(function (d) {
      var sum = d.querySelector('summary');
      if (sum) sum.addEventListener('click', function (e) { if (!accMq.matches) e.preventDefault(); });
    });
  }

  /* ---------- Cartes : devant et dos, au doigt sur mobile ---------- */
  function bindDuo(scope) {
    (scope || document).querySelectorAll('[data-ofx-duo]').forEach(function (strip) {
      if (strip.hasAttribute('data-ofx-duo-on')) return;
      strip.setAttribute('data-ofx-duo-on', '');
      var dots = strip.parentNode.querySelectorAll('.ofx-art__dots i');
      var tick = 0;
      strip.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () {
          tick = 0;
          var i = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        });
      }, { passive: true });
    });
  }
  bindDuo();

  /* ---------- Flocage sur photo : ajustement et couleur lisible ---------- */
  /* Le nom et le numéro sont resserrés horizontalement s'ils dépassent la zone de flocage du dos. */
  function fitPrints(prints) {
    prints.forEach(function (p) {
      var w = p.clientWidth;
      if (!w) return;
      [['.ofx-shot__name', .56], ['.ofx-shot__number', .58]].forEach(function (pair) {
        var el = p.querySelector(pair[0]);
        if (!el) return;
        el.style.transform = '';
        var need = el.scrollWidth, room = w * pair[1];
        el.style.transform = need > room ? 'scaleX(' + (room / need).toFixed(3) + ')' : '';
      });
    });
  }
  /* Blanc sur un maillot foncé, noir sur un maillot clair, d'après la zone du dos où se pose le flocage. */
  function tonePrints(img, prints) {
    if (!img || !prints.length) return;
    function run() {
      try {
        var c = document.createElement('canvas');
        c.width = 48; c.height = 48;
        var x = c.getContext('2d', { willReadFrequently: true });
        var W = img.naturalWidth, H = img.naturalHeight;
        x.drawImage(img, W * .38, H * .3, W * .24, H * .34, 0, 0, 48, 48);
        var px = x.getImageData(0, 0, 48, 48).data, r = 0, g = 0, b = 0, k = 0;
        for (var i = 0; i < px.length; i += 4) {
          if (px[i + 3] < 200) continue;
          r += px[i]; g += px[i + 1]; b += px[i + 2]; k++;
        }
        if (!k) return;
        var lum = (.2126 * r + .7152 * g + .0722 * b) / k / 255;
        prints.forEach(function (p) { p.classList.toggle('is-dark-ink', lum > .62); });
      } catch (e) { /* image non lisible : on garde le blanc par défaut */ }
    }
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
  }

  /* ---------- Saisie nom / numéro ---------- */
  function bindPrint(root, onChange) {
    var nameIn = root.querySelector('[data-ofx-name]');
    var numIn = root.querySelector('[data-ofx-number]');
    var hint = root.querySelector('[data-ofx-hint]');
    var outName = root.querySelectorAll('[data-ofx-out-name]');
    var outNum = root.querySelectorAll('[data-ofx-out-number]');
    if (!nameIn && !numIn) return null;
    function setHint(msg) {
      if (!hint) return;
      if (msg) { hint.textContent = msg; hint.setAttribute('data-error', ''); }
      else { hint.textContent = hint.getAttribute('data-default'); hint.removeAttribute('data-error'); }
    }
    var prints = root.querySelectorAll('[data-ofx-print]');
    function render(fromUser) {
      var n = nameIn ? nameIn.value.trim() : '';
      var d = numIn ? numIn.value : '';
      outName.forEach(function (el) { el.textContent = n || (el.closest('[data-ofx-stage], [data-ofx-print]') ? 'VOTRE NOM' : ''); });
      outNum.forEach(function (el) {
        var next = d === '' ? (el.closest('[data-ofx-stage], [data-ofx-print]') ? '10' : '') : d;
        if (fromUser && el.textContent !== next && el.animate && !reduceMotion && /__num/.test(el.className)) {
          el.animate([{ scale: 1.14, opacity: .55 }, { scale: 1, opacity: 1 }], { duration: 700, easing: 'cubic-bezier(.16, 1, .3, 1)' });
        }
        el.textContent = next;
      });
      prints.forEach(function (p) { p.classList.toggle('is-empty', !n && d === ''); });
      fitPrints(prints);
      if (onChange) onChange(n, d, fromUser);
    }
    if (nameIn) nameIn.addEventListener('input', function () {
      var upper = nameIn.value.toUpperCase();
      var clean = upper.replace(NAME_RE, '').slice(0, 12);
      setHint(clean !== upper ? 'Le nom accepte uniquement des lettres, espaces, points, tirets et apostrophes.' : '');
      nameIn.value = clean;
      nameIn.removeAttribute('aria-invalid');
      render(true);
    });
    if (numIn) numIn.addEventListener('input', function () {
      var raw = numIn.value;
      var digits = raw.replace(/\D/g, '').slice(0, 3);
      setHint(digits !== raw ? 'Le numéro accepte uniquement des chiffres, trois au plus (0 à 999).' : '');
      numIn.value = digits;
      numIn.removeAttribute('aria-invalid');
      render(true);
    });
    render(false);
    return { name: nameIn, number: numIn, setHint: setHint };
  }

  /* ---------- Accueil : les clubs défilent tout seuls, sans défilement forcé ---------- */
  document.querySelectorAll('[data-ofx-rooms]').forEach(function (root) {
    var stage = root.querySelector('.ofx-rooms__stage');
    var rooms = root.querySelectorAll('[data-ofx-room]');
    var dots = root.querySelectorAll('[data-ofx-room-go]');
    var pauseBtn = root.querySelector('[data-ofx-rooms-pause]');
    var delay = Math.max(3, Number(root.getAttribute('data-interval')) || 5) * 1000;
    var current = 0, prevTimer = 0, timer = 0;
    var userPaused = reduceMotion, focusInside = false, onScreen = true, started = false;
    function show(i) {
      i = (i + rooms.length) % rooms.length;
      if (i === current || !rooms[i]) return;
      var old = rooms[current];
      clearTimeout(prevTimer);
      rooms.forEach(function (r) { r.classList.remove('is-prev'); });
      old.classList.remove('is-active');
      old.classList.add('is-prev');
      old.setAttribute('aria-hidden', 'true');
      old.querySelectorAll('.ofx-room__caption a').forEach(function (a) { a.tabIndex = -1; });
      var next = rooms[i];
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
      next.querySelectorAll('.ofx-room__caption a').forEach(function (a) { a.removeAttribute('tabindex'); });
      prevTimer = setTimeout(function () { old.classList.remove('is-prev'); }, 1200);
      paint(next);
      dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      current = i;
    }
    function paint(room) {
      var cs = getComputedStyle(room);
      stage.style.setProperty('--cur-fg', cs.getPropertyValue('--fg').trim());
      stage.style.setProperty('--cur-bg', cs.getPropertyValue('--bg').trim());
      root.style.setProperty('--hdr-bg', cs.getPropertyValue('--bg').trim());
      root.style.setProperty('--hdr-fg', cs.getPropertyValue('--fg').trim());
      hdrUpdate();
    }
    function running() { return started && !userPaused && !focusInside && onScreen && !document.hidden && rooms.length > 1; }
    function schedule() {
      clearTimeout(timer);
      stage.setAttribute('aria-live', running() ? 'off' : 'polite');
      if (running()) timer = setTimeout(function () { show(current + 1); schedule(); }, delay);
    }
    function setPaused(p) {
      userPaused = p;
      if (pauseBtn) {
        pauseBtn.textContent = p ? 'Lecture' : 'Pause';
        pauseBtn.setAttribute('aria-label', p ? 'Reprendre le défilement des clubs' : 'Mettre en pause le défilement des clubs');
      }
      schedule();
    }
    paint(rooms[0]);
    setPaused(userPaused);
    setTimeout(function () { root.classList.add('is-ready'); started = true; schedule(); }, intro ? 1000 : 120);
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!userPaused); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(Number(d.getAttribute('data-ofx-room-go'))); schedule(); });
    });
    root.addEventListener('focusin', function () { focusInside = true; schedule(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focusInside = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        document.documentElement.classList.toggle('ofx-hero-on', onScreen);
        schedule();
      }, { threshold: .25 }).observe(root);
    }
    /* Glisser du doigt (ou de la souris) pour changer de club */
    var startX = null, startY = 0, swiped = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      startX = e.clientX; startY = e.clientY; swiped = false;
    });
    stage.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        swiped = true;
        show(current + (dx < 0 ? 1 : -1));
        schedule();
      }
    });
    stage.addEventListener('pointercancel', function () { startX = null; });
    stage.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); swiped = false; } }, true);
  });

  /* ---------- Le vestiaire : anneau 3D, on le fait tourner du doigt ---------- */
  function hexRgb(h) {
    h = String(h || '#000').replace('#', '');
    if (h.length === 3) h = h.replace(/./g, '$&$&');
    return [parseInt(h.slice(0, 2), 16) || 0, parseInt(h.slice(2, 4), 16) || 0, parseInt(h.slice(4, 6), 16) || 0];
  }
  function glowOf(a, b) {
    function score(h) { var c = hexRgb(h); var mx = Math.max.apply(null, c), mn = Math.min.apply(null, c); return (mx - mn) + .3 * (.2126 * c[0] + .7152 * c[1] + .0722 * c[2]); }
    return score(a) >= score(b) ? a : b;
  }
  document.querySelectorAll('[data-ofx-vest]').forEach(function (root) {
    var stage = root.querySelector('[data-ofx-vest-stage]');
    var ring = root.querySelector('[data-ofx-vest-ring]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ofx-vest-item]'));
    var n = items.length;
    if (!stage || !ring || n < 3) return;
    var step = 360 / n;
    var nameEl = root.querySelector('[data-ofx-vest-name]');
    var linkEl = root.querySelector('[data-ofx-vest-link]');
    var countEl = root.querySelector('[data-ofx-vest-count]');
    var statusEl = root.querySelector('[data-ofx-vest-status]');
    var ghost = root.querySelector('[data-ofx-vest-ghost]');
    var AUTO = -0.006; /* degrés par milliseconde : un tour par minute */
    var rot = 0, vel = 0, target = null, front = -1, raf = 0, last = 0;
    var dragging = false, lastX = 0, lastT = 0, moved = 0, hover = false, onScreen = false, idleUntil = 0, wheelT = 0;
    var degPerPx = 1;
    root.style.setProperty('--n', n);
    function pad(v) { return v < 10 ? '0' + v : String(v); }
    function measure() {
      var w = items[0].offsetWidth || 200;
      var r = Math.round((w * 1.2 / 2) / Math.tan(Math.PI / n));
      root.style.setProperty('--r', r + 'px');
      degPerPx = step / (w * 1.2);
    }
    function setFront(i, announce) {
      front = i;
      var it = items[i];
      var name = it.getAttribute('data-name');
      if (nameEl) nameEl.textContent = name;
      if (ghost) ghost.textContent = name;
      items.forEach(function (x, k) { x.classList.toggle('is-front', k === i); });
      if (linkEl) { linkEl.href = it.getAttribute('href'); linkEl.textContent = 'Voir les maillots ' + name; }
      if (countEl) countEl.textContent = pad(i + 1) + ' / ' + pad(n);
      root.style.setProperty('--glow', glowOf(it.getAttribute('data-k1'), it.getAttribute('data-k2')));
      if (announce && statusEl) statusEl.textContent = name + ', ' + (i + 1) + ' sur ' + n;
    }
    function apply() {
      ring.style.setProperty('--rot', rot.toFixed(3) + 'deg');
      var best = 0, bestCos = -2;
      for (var i = 0; i < n; i++) {
        var c = Math.cos((i * step + rot) * Math.PI / 180);
        if (c > bestCos) { bestCos = c; best = i; }
        items[i].style.opacity = c <= 0 ? '0' : (.16 + .84 * c * c * c).toFixed(3);
      }
      if (best !== front) setFront(best, false);
    }
    function tick(t) {
      raf = 0;
      var dt = last ? Math.min(48, t - last) : 16;
      last = t;
      if (!dragging) {
        if (target !== null) {
          var diff = target - rot;
          rot += diff * Math.min(1, dt / 150);
          if (Math.abs(diff) < .03) { rot = target; target = null; }
        } else if (Math.abs(vel) > .004) {
          rot += vel * dt;
          vel *= Math.pow(.93, dt / 16);
          if (Math.abs(vel) <= .004) { vel = 0; target = Math.round(rot / step) * step; }
        } else if (!reduceMotion && !hover && t > idleUntil) {
          rot += AUTO * dt;
        }
      }
      apply();
      if (onScreen && !document.hidden) raf = requestAnimationFrame(tick);
      else last = 0;
    }
    function kick() { if (!raf && onScreen) { last = 0; raf = requestAnimationFrame(tick); } }
    function go(i, announce) {
      i = (i + n) % n;
      var base = -i * step;
      target = base + 360 * Math.round((rot - base) / 360);
      vel = 0;
      idleUntil = performance.now() + 4500;
      if (announce && statusEl) statusEl.textContent = items[i].getAttribute('data-name') + ', ' + (i + 1) + ' sur ' + n;
      if (onScreen) kick(); else { rot = target; target = null; apply(); }
    }
    measure();
    apply();
    root.classList.add('is-live');
    window.addEventListener('resize', function () { measure(); apply(); });

    var prev = root.querySelector('[data-ofx-vest-prev]');
    var next = root.querySelector('[data-ofx-vest-next]');
    if (prev) prev.addEventListener('click', function () { go(front - 1, true); });
    if (next) next.addEventListener('click', function () { go(front + 1, true); });
    root.addEventListener('keydown', function (e) {
      if (e.target.matches('input, textarea, select')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(front - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(front + 1, true); }
    });

    /* Glisser : seul le geste horizontal fait tourner, le défilement vertical reste libre */
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = 0; lastX = e.clientX; lastT = performance.now(); vel = 0; target = null;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now();
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      rot += dx * degPerPx;
      vel = (dx * degPerPx) / Math.max(8, now - lastT);
      lastT = now;
      moved += Math.abs(dx);
      if (moved > 6) stage.classList.add('is-dragging');
      kick();
    });
    function release() {
      if (!dragging) return;
      dragging = false;
      stage.classList.remove('is-dragging');
      if (performance.now() - lastT > 90) vel = 0;
      vel = Math.max(-.6, Math.min(.6, vel));
      if (Math.abs(vel) <= .004) target = Math.round(rot / step) * step;
      idleUntil = performance.now() + 3500;
      kick();
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
    stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    stage.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; idleUntil = performance.now() + 900; } });
    stage.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      rot -= e.deltaX * degPerPx * .7;
      vel = 0; target = null;
      idleUntil = performance.now() + 3500;
      clearTimeout(wheelT);
      wheelT = setTimeout(function () { target = Math.round(rot / step) * step; kick(); }, 140);
      kick();
    }, { passive: false });
    ring.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ofx-vest-item]');
      if (!a) return;
      if (moved > 6) { e.preventDefault(); moved = 0; return; }
      var i = items.indexOf(a);
      if (i !== front) { e.preventDefault(); go(i, true); }
    });
    ring.addEventListener('dragstart', function (e) { e.preventDefault(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen) kick();
      }, { rootMargin: '120px 0px' }).observe(root);
    } else { onScreen = true; kick(); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
  });

  /* ---------- Index des clubs : la page prend la couleur du club survolé ---------- */
  document.querySelectorAll('[data-ofx-index]').forEach(function (section) {
    var timer = 0;
    var ghost = section.querySelector('[data-ofx-ghost]');
    function flood(a) {
      clearTimeout(timer);
      section.style.setProperty('--flood-bg', a.getAttribute('data-bg'));
      section.style.setProperty('--flood-fg', a.getAttribute('data-fg'));
      section.style.setProperty('--flood-ac', a.getAttribute('data-ac'));
      if (ghost && ghost.textContent !== a.textContent) {
        var r = a.getBoundingClientRect();
        ghost.textContent = a.textContent;
        ghost.style.setProperty('--gl', Math.max(a.textContent.length, 4));
        ghost.style.setProperty('--gy', Math.round(r.top + r.height / 2 - section.getBoundingClientRect().top) + 'px');
        if (ghost.animate && !reduceMotion) {
          ghost.animate([{ opacity: 0, translate: '0 6%' }, { opacity: 1, translate: '0 0' }], { duration: 600, easing: 'cubic-bezier(.16, 1, .3, 1)' });
        }
      }
      section.classList.add('is-flooded');
    }
    function dry() { timer = setTimeout(function () { section.classList.remove('is-flooded'); }, 80); }
    section.querySelectorAll('[data-ofx-flood]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { flood(a); });
      a.addEventListener('focus', function () { flood(a); });
      a.addEventListener('mouseleave', dry);
      a.addEventListener('blur', dry);
    });
  });

  /* ---------- Aperçu du flocage (accueil) ---------- */
  document.querySelectorAll('[data-ofx-configurator]').forEach(function (root) {
    bindPrint(root);
    var select = root.querySelector('[data-ofx-club]');
    var stage = root.querySelector('[data-ofx-stage]');
    var jersey = root.querySelector('[data-ofx-floc-jersey]');
    var link = root.querySelector('[data-ofx-club-link]');
    var label = root.querySelector('[data-ofx-club-name]');
    if (!select || !jersey) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      jersey.className = jersey.className.replace(/ofx-kit--\S+/, 'ofx-kit--' + opt.getAttribute('data-pattern'));
      jersey.style.setProperty('--k1', opt.getAttribute('data-k1'));
      jersey.style.setProperty('--k2', opt.getAttribute('data-k2'));
      jersey.style.setProperty('--print', opt.getAttribute('data-print'));
      if (stage) {
        stage.style.setProperty('--bg', opt.getAttribute('data-k2'));
        stage.style.setProperty('--num', opt.getAttribute('data-k1'));
      }
      if (link) link.href = opt.value;
      if (label) label.textContent = opt.getAttribute('data-name');
    });
  });

  /* ---------- Fiche produit ---------- */
  document.querySelectorAll('[data-ofx-product]').forEach(function (root) {
    var form = root.querySelector('form');
    var dataEl = root.querySelector('[data-ofx-variants]');
    var idSelect = root.querySelector('[data-ofx-variant-id]');
    var priceEl = root.querySelector('[data-ofx-price]');
    var submit = root.querySelector('[data-ofx-submit]');
    var flag = root.querySelector('[data-ofx-floc-flag]');
    var errorEl = root.querySelector('[data-ofx-form-error]');
    var flip = root.querySelector('[data-ofx-stage] [data-ofx-flip]');
    var shot = root.querySelector('[data-ofx-shot]');
    var viewBtns = root.querySelectorAll('[data-ofx-view]');
    var sticky = root.querySelector('[data-ofx-sticky]');
    var stickyPrice = sticky && sticky.querySelector('[data-ofx-sticky-price]');
    var stickyVariant = sticky && sticky.querySelector('[data-ofx-sticky-variant]');
    var stickyBtn = sticky && sticky.querySelector('[data-ofx-sticky-btn]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    var currency = root.getAttribute('data-currency') || 'EUR';
    var fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: currency });

    function setView(v) {
      if (!flip && !shot) return;
      if (flip) flip.classList.toggle('is-back', v === 'back');
      if (shot) shot.classList.toggle('is-back', v === 'back');
      viewBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ofx-view') === v ? 'true' : 'false'); });
    }
    viewBtns.forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-ofx-view')); }); });

    /* Le maillot dessiné tourne quand on le fait glisser (devant / dos) */
    var stageEl = root.querySelector('[data-ofx-stage]');
    if (flip && stageEl) {
      var spin = { on: false, x: 0, base: 0, angle: 0, moved: 0 };
      stageEl.classList.add('is-spinnable');
      stageEl.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button, a, input, label')) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        spin.on = true; spin.x = e.clientX; spin.moved = 0;
        spin.base = flip.classList.contains('is-back') ? 180 : 0;
        spin.angle = spin.base;
      });
      window.addEventListener('pointermove', function (e) {
        if (!spin.on) return;
        var dx = e.clientX - spin.x;
        spin.moved = Math.max(spin.moved, Math.abs(dx));
        if (spin.moved < 5) return;
        stageEl.classList.add('is-spinning');
        flip.style.transition = 'none';
        spin.angle = spin.base + dx * .6;
        flip.style.transform = 'rotateY(' + spin.angle.toFixed(1) + 'deg)';
      });
      var spinEnd = function () {
        if (!spin.on) return;
        spin.on = false;
        stageEl.classList.remove('is-spinning');
        if (spin.moved < 5) return;
        var snap = Math.round(spin.angle / 180) * 180;
        var back = Math.abs(Math.round(snap / 180)) % 2 === 1;
        var settled = false;
        var settle = function () {
          if (settled) return;
          settled = true;
          flip.removeEventListener('transitionend', settle);
          flip.style.transition = 'none';
          flip.style.transform = '';
          setView(back ? 'back' : 'front');
          void flip.offsetWidth;
          flip.style.transition = '';
        };
        flip.style.transition = 'transform .7s cubic-bezier(.16, 1, .3, 1)';
        flip.style.transform = 'rotateY(' + snap + 'deg)';
        flip.addEventListener('transitionend', settle);
        setTimeout(settle, 900);
      };
      window.addEventListener('pointerup', spinEnd);
      window.addEventListener('pointercancel', spinEnd);
    }

    var print = bindPrint(root, function (n, d, fromUser) {
      if (flag) flag.disabled = !(n || d !== '');
      if (fromUser) setView('back');
    });

    if (shot) {
      var swipe = null;
      shot.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { swipe = null; return; }
        swipe = { x: e.touches[0].clientX, y: e.touches[0].clientY, moved: false };
      }, { passive: true });
      shot.addEventListener('touchend', function (e) {
        if (!swipe) return;
        var t = e.changedTouches[0], dx = t.clientX - swipe.x, dy = t.clientY - swipe.y;
        swipe = null;
        if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        shot.setAttribute('data-ofx-swiped', '');
        setView(dx < 0 ? 'back' : 'front');
      }, { passive: true });
      shot.addEventListener('click', function () {
        if (shot.hasAttribute('data-ofx-swiped')) { shot.removeAttribute('data-ofx-swiped'); return; }
        setView(shot.classList.contains('is-back') ? 'front' : 'back');
      });
      var shotPrints = root.querySelectorAll('[data-ofx-print]');
      tonePrints(shot.querySelector('.ofx-shot__face--back img'), shotPrints);
      var refit = function () { fitPrints(shotPrints); };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
      var fitTick = 0;
      window.addEventListener('resize', function () {
        if (fitTick) return;
        fitTick = requestAnimationFrame(function () { fitTick = 0; refit(); });
      });
      root.querySelectorAll('.ofx-shot__frame img').forEach(function (im) { if (!im.complete) im.addEventListener('load', refit, { once: true }); });
    }

    var fieldsets = root.querySelectorAll('[data-ofx-option]');
    function selected() {
      var vals = [];
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals.push(c ? c.value : null);
        var out = fs.querySelector('[data-ofx-option-value]');
        if (out && c) out.textContent = c.value;
      });
      return vals;
    }
    function update() {
      if (!fieldsets.length) return;
      var vals = selected();
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); });
      if (!match) {
        if (submit) { submit.disabled = true; submit.textContent = 'Combinaison indisponible'; }
        return;
      }
      if (idSelect) idSelect.value = String(match.id);
      if (priceEl) priceEl.textContent = fmt.format(match.price / 100);
      if (submit) { submit.disabled = !match.available; submit.textContent = match.available ? 'Ajouter au panier' : 'Indisponible'; }
      if (stickyPrice) stickyPrice.textContent = fmt.format(match.price / 100);
      if (stickyVariant) stickyVariant.textContent = match.title;
      if (stickyBtn) { stickyBtn.disabled = !match.available; stickyBtn.textContent = match.available ? 'Ajouter au panier' : 'Indisponible'; }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    update();

    /* La barre d'achat apparaît quand le bouton principal est passé au-dessus de l'écran */
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(submit);
    }

    if (form) form.addEventListener('submit', function (e) {
      if (!print || !print.number) return;
      var d = print.number.value;
      if (d !== '' && !/^\d{1,3}$/.test(d)) {
        e.preventDefault();
        print.number.setAttribute('aria-invalid', 'true');
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Le numéro doit compter trois chiffres au plus, de 0 à 999.'; }
        print.number.focus();
      } else if (errorEl) {
        errorEl.hidden = true;
      }
    });
  });

  /* ---------- Le maillot suit la souris ---------- */
  if (finePointer && !reduceMotion) {
    document.querySelectorAll('[data-ofx-tilt]').forEach(function (el) {
      var raf = 0, mx = 0, my = 0;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        mx = Math.max(-1, Math.min(1, (e.clientX - r.left) / r.width * 2 - 1));
        my = Math.max(-1, Math.min(1, (e.clientY - r.top) / r.height * 2 - 1));
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          el.style.setProperty('--mx', mx.toFixed(3));
          el.style.setProperty('--my', my.toFixed(3));
        });
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--mx', '0');
        el.style.setProperty('--my', '0');
      });
    });
  }

  /* ---------- Curseur « Voir » ---------- */
  if (finePointer && !reduceMotion && document.querySelector('[data-ofx-cursor]')) {
    var cur = document.createElement('div');
    cur.className = 'ofx-cursor';
    cur.setAttribute('aria-hidden', 'true');
    cur.appendChild(document.createElement('span'));
    document.body.appendChild(cur);
    document.documentElement.classList.add('ofx-has-cursor');
    var curLabel = cur.firstChild, cx = 0, cy = 0, tx = 0, ty = 0, moving = false, seen = false, onEl = null;
    function curLoop() {
      cx += (tx - cx) * .22;
      cy += (ty - cy) * .22;
      cur.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      if (Math.abs(tx - cx) + Math.abs(ty - cy) > .4) requestAnimationFrame(curLoop);
      else moving = false;
    }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY;
      if (!seen) { cx = tx; cy = ty; seen = true; }
      var t = e.target && e.target.closest ? e.target.closest('[data-ofx-cursor]') : null;
      if (t !== onEl) {
        onEl = t;
        if (t) { curLabel.textContent = t.getAttribute('data-ofx-cursor'); cur.classList.add('is-on'); }
        else cur.classList.remove('is-on');
      }
      if (!moving) { moving = true; requestAnimationFrame(curLoop); }
    }, { passive: true });
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget) { onEl = null; cur.classList.remove('is-on'); } });
  }

  /* ---------- Apparitions au défilement ---------- */
  if (canAnim) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        revealIO.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    document.querySelectorAll('.ofx-split').forEach(function (el) {
      if (el.closest('.ofx-room')) el.classList.add('is-in');
      else revealIO.observe(el);
    });
    document.querySelectorAll('.ofx-grid').forEach(function (grid) {
      var cols = Math.max(1, getComputedStyle(grid).gridTemplateColumns.split(' ').length);
      Array.prototype.forEach.call(grid.children, function (li, k) { li.style.setProperty('--d', (k % cols) * 110 + 'ms'); });
    });
    document.querySelectorAll('.ofx-packs__item').forEach(function (li, k) { li.style.setProperty('--d', k * 140 + 'ms'); });
    document.querySelectorAll('.ofx-h2, .ofx-grid > li, .ofx-packs__item, .ofx-index__league, .ofx-footer__mark').forEach(function (el) { revealIO.observe(el); });
  }

  /* ---------- Mémoire locale (sans erreur si le navigateur la bloque) ---------- */
  function keep(store, k, v) {
    try {
      var s = window[store];
      if (v === undefined) return s.getItem(k);
      s.setItem(k, v);
    } catch (e) { return null; }
    return v;
  }
  var firstPage = !keep('sessionStorage', 'ofx-seen');
  keep('sessionStorage', 'ofx-seen', '1');
  function cardShow(el) {
    el.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
  }
  function cardHide(el) {
    el.classList.remove('is-open');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 600);
  }

  /* ---------- Cookies : bandeau maison, choix transmis à Shopify ---------- */
  var consentEl = document.querySelector('[data-ofx-consent]');
  var consentDone = !consentEl, consentShown = false, consentWaiters = [];
  var privacy = null;
  function onConsent(cb) { if (consentDone) cb(); else consentWaiters.push(cb); }
  function consentSettle() {
    if (consentDone) return;
    consentDone = true;
    consentWaiters.splice(0).forEach(function (cb) { cb(); });
  }
  function loadPrivacy(cb) {
    var called = false;
    function done(api) { if (!called) { called = true; cb(api || null); } }
    var S = window.Shopify;
    if (S && S.customerPrivacy) return done(S.customerPrivacy);
    setTimeout(function () { done(window.Shopify && window.Shopify.customerPrivacy); }, 3000);
    if (S && typeof S.loadFeatures === 'function') {
      try {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { done(err ? null : window.Shopify.customerPrivacy); });
      } catch (e) { done(null); }
    } else done(null);
  }
  function consentNow() {
    var c = { preferences: null, analytics: null, marketing: null };
    if (privacy && privacy.currentVisitorConsent) {
      try {
        var v = privacy.currentVisitorConsent() || {};
        ['preferences', 'analytics', 'marketing'].forEach(function (k) { if (v[k] === 'yes') c[k] = true; else if (v[k] === 'no') c[k] = false; });
      } catch (e) {}
    }
    var local = null;
    try { local = JSON.parse(keep('localStorage', 'ofx-consent') || 'null'); } catch (e) {}
    if (local) {
      if (c.preferences === null) c.preferences = !!local.p;
      if (c.analytics === null) c.analytics = !!local.a;
      if (c.marketing === null) c.marketing = !!local.m;
    }
    return c;
  }
  function consentStateText() {
    var out = document.querySelectorAll('[data-ofx-consent-state]');
    if (!out.length) return;
    var c = consentNow();
    var txt;
    if (c.preferences === null && c.analytics === null && c.marketing === null) txt = 'Vous n\'avez encore fait aucun choix.';
    else {
      var w = function (v) { return v ? 'acceptés' : 'refusés'; };
      txt = 'Vos choix actuels : cookies de préférences ' + w(c.preferences) + ', de statistiques ' + w(c.analytics) + ', de marketing ' + w(c.marketing) + '.';
    }
    out.forEach(function (el) { el.textContent = txt; });
  }
  if (consentEl) {
    var prefsForm = consentEl.querySelector('[data-ofx-consent-prefs]');
    var customBtn = consentEl.querySelector('[data-ofx-consent-custom]');
    var consentHeight = function () {
      var h = consentEl.hidden ? 0 : consentEl.offsetHeight;
      document.documentElement.style.setProperty('--ofx-consent-h', h + 'px');
    };
    var togglePrefs = function (open) {
      prefsForm.hidden = !open;
      customBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      consentHeight();
    };
    var bannerOpen = function (withPrefs) {
      var c = consentNow();
      ['preferences', 'analytics', 'marketing'].forEach(function (k) { prefsForm.elements[k].checked = !!c[k]; });
      consentShown = true;
      cardShow(consentEl);
      togglePrefs(!!withPrefs);
      setTimeout(consentHeight, 60);
      if (withPrefs) setTimeout(function () { prefsForm.elements.preferences.focus(); }, 120);
    };
    var bannerClose = function () {
      cardHide(consentEl);
      document.documentElement.style.setProperty('--ofx-consent-h', '0px');
    };
    var consentSave = function (c) {
      keep('localStorage', 'ofx-consent', JSON.stringify({ p: c.preferences, a: c.analytics, m: c.marketing, t: Date.now() }));
      var finished = false;
      var finish = function () {
        if (finished) return;
        finished = true;
        bannerClose();
        consentStateText();
        setTimeout(consentSettle, 400);
      };
      if (privacy && privacy.setTrackingConsent) {
        try {
          privacy.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing }, finish);
        } catch (e) { finish(); }
        setTimeout(finish, 1500);
      } else finish();
    };
    consentEl.querySelectorAll('[data-ofx-consent-all]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-ofx-consent-all') === 'true';
        consentSave({ preferences: v, analytics: v, marketing: v });
      });
    });
    customBtn.addEventListener('click', function () { togglePrefs(prefsForm.hidden); });
    prefsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      consentSave({ preferences: prefsForm.elements.preferences.checked, analytics: prefsForm.elements.analytics.checked, marketing: prefsForm.elements.marketing.checked });
    });
    document.querySelectorAll('[data-ofx-consent-open]').forEach(function (b) {
      b.addEventListener('click', function () { bannerOpen(true); });
    });
    window.addEventListener('resize', function () { if (!consentEl.hidden) consentHeight(); });
    loadPrivacy(function (api) {
      privacy = api;
      var saved = null;
      try { saved = JSON.parse(keep('localStorage', 'ofx-consent') || 'null'); } catch (e) {}
      /* Un choix est redemandé au bout de six mois */
      if (saved && (!saved.t || Date.now() - saved.t > 182 * 864e5)) {
        saved = null;
        try { window.localStorage.removeItem('ofx-consent'); } catch (e) {}
      }
      var c = consentNow();
      var unset = c.preferences === null && c.analytics === null && c.marketing === null;
      var need = unset;
      if (saved) {
        /* Choix déjà fait ici : on ne rouvre pas le bandeau, on le retransmet à Shopify s'il l'a perdu */
        need = false;
        if (api && api.setTrackingConsent) {
          var cur = {};
          try { cur = api.currentVisitorConsent() || {}; } catch (e) {}
          var want = { preferences: !!saved.p, analytics: !!saved.a, marketing: !!saved.m };
          var differs = ['preferences', 'analytics', 'marketing'].some(function (k) { return cur[k] !== (want[k] ? 'yes' : 'no'); });
          if (differs) {
            try { api.setTrackingConsent({ analytics: want.analytics, marketing: want.marketing, preferences: want.preferences, sale_of_data: want.marketing }, function () {}); } catch (e) {}
          }
        }
      }
      consentStateText();
      if (need) {
        bannerOpen(false);
        /* La bannière native de Shopify est encore active : on lui laisse la place */
        setTimeout(function () {
          var native = document.getElementById('shopify-pc__banner');
          if (native && native.offsetParent !== null && !consentDone) { bannerClose(); consentSettle(); }
        }, 2500);
      } else consentSettle();
    });
  } else consentStateText();

  /* ---------- Rappel de panier : le visiteur revient, son panier l'attend ---------- */
  var reminder = document.querySelector('[data-ofx-reminder]');
  var reminderShown = false;
  if (reminder && firstPage) {
    reminderShown = true;
    setTimeout(function () { cardShow(reminder); }, intro ? 2800 : 1500);
    reminder.querySelectorAll('[data-ofx-reminder-close], [data-ofx-reminder-go]').forEach(function (b) {
      b.addEventListener('click', function () { cardHide(reminder); });
    });
  }

  /* ---------- Fenêtre newsletter : −10 % dès l'arrivée, cumulable avec les promotions ---------- */
  var welcome = document.querySelector('[data-ofx-welcome]');
  var welcomeTab = document.querySelector('[data-ofx-welcome-tab]');
  if (welcome) {
    var dialog = welcome.querySelector('.ofx-welcome__dialog');
    var posted = welcome.getAttribute('data-posted');
    var state = keep('localStorage', 'ofx-welcome');
    var welcomeLast = null, welcomeOpened = false;
    var openWelcome = function (focusEmail) {
      welcomeOpened = true;
      if (welcomeTab) welcomeTab.hidden = true;
      if (welcome.classList.contains('is-open')) return;
      welcomeLast = document.activeElement;
      document.body.classList.add('is-locked');
      cardShow(welcome);
      setTimeout(function () {
        var email = focusEmail && welcome.querySelector('input[type="email"]');
        (email || dialog).focus({ preventScroll: true });
      }, 90);
    };
    var closeWelcome = function () {
      if (!welcome.classList.contains('is-open')) return;
      cardHide(welcome);
      if (!overlay || overlay.hidden) document.body.classList.remove('is-locked');
      if (welcomeLast && document.contains(welcomeLast) && welcomeLast.focus) welcomeLast.focus({ preventScroll: true });
      if (keep('localStorage', 'ofx-welcome') !== 'subscribed') {
        keep('localStorage', 'ofx-welcome', String(Date.now()));
        if (welcomeTab) setTimeout(function () { welcomeTab.hidden = false; }, 600);
      }
    };
    welcome.querySelectorAll('[data-ofx-welcome-close]').forEach(function (b) { b.addEventListener('click', closeWelcome); });
    if (welcomeTab) welcomeTab.addEventListener('click', function () { openWelcome(true); });
    document.addEventListener('keydown', function (e) {
      if (!welcome.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeWelcome(); return; }
      if (e.key === 'Tab') {
        var items = Array.prototype.filter.call(dialog.querySelectorAll('a[href], button, input:not([type="hidden"])'), function (el) { return el.offsetParent !== null && !el.disabled; });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    welcome.querySelectorAll('[data-ofx-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-ofx-copy');
        var done = function () { b.textContent = 'Code copié'; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () {});
      });
    });

    if (posted === 'ok') {
      keep('localStorage', 'ofx-welcome', 'subscribed');
      openWelcome(false);
    } else if (posted === 'error') {
      openWelcome(true);
    } else if (state !== 'subscribed') {
      var recentlyClosed = Date.now() - (Number(state) || 0) < 7 * 864e5;
      if (recentlyClosed || reminderShown) {
        if (welcomeTab) welcomeTab.hidden = false;
      } else {
        var wait = (Number(welcome.getAttribute('data-delay')) || 2) * 1000 + (intro ? 1700 : 0);
        onConsent(function () {
          setTimeout(function () { if (!welcomeOpened) openWelcome(false); }, consentShown ? 1200 : wait);
        });
        /* Le visiteur n'a pas encore répondu au bandeau cookies : l'offre l'attend dans l'onglet */
        setTimeout(function () { if (!welcomeOpened && !consentDone && welcomeTab) welcomeTab.hidden = false; }, 12000);
      }
    }
  }

  /* ---------- Filtres et tri ---------- */
  document.querySelectorAll('[data-ofx-filters]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-ofx-autosubmit], input[type="checkbox"]')) form.submit();
    });
  });

  /* ---------- Panier : mise à jour des quantités ---------- */
  document.querySelectorAll('[data-ofx-cart]').forEach(function (form) {
    var updateBtn = form.querySelector('[data-ofx-update]');
    form.querySelectorAll('[data-ofx-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (updateBtn && form.requestSubmit) form.requestSubmit(updateBtn);
        else if (updateBtn) updateBtn.click();
      });
    });
  });

  /* ---------- Demande de produit : champs selon le type ---------- */
  document.querySelectorAll('[data-ofx-request-cat]').forEach(function (select) {
    var form = select.closest('form');
    function sync() {
      form.querySelectorAll('[data-ofx-request-group]').forEach(function (g) {
        var on = g.getAttribute('data-ofx-request-group') === select.value;
        g.hidden = !on;
        g.querySelectorAll('input, select, textarea').forEach(function (f) { f.disabled = !on; });
      });
    }
    select.addEventListener('change', sync);
    sync();
  });

  /* ---------- Paliers de pack (fiche maillot) ---------- */
  document.querySelectorAll('[data-ofx-tiers]').forEach(function (box) {
    var form = box.closest('form');
    var qty = form ? form.querySelector('[data-ofx-qty-input]') : null;
    var tiers = box.querySelectorAll('[data-ofx-tier]');
    function mark(n) {
      tiers.forEach(function (t) {
        var v = Number(t.getAttribute('data-ofx-tier'));
        var on = v === 4 ? n >= 4 : v === n;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        var n = Number(t.getAttribute('data-ofx-tier'));
        if (qty) qty.value = n;
        mark(n);
      });
    });
    if (qty) qty.addEventListener('input', function () { mark(Number(qty.value) || 1); });
  });

  /* ---------- Tiroir panier ---------- */
  var drawer = document.querySelector('[data-ofx-drawer]');
  var drawerLast = null;
  var SECTION = 'ofx-cart-drawer';
  function drawerOpen() {
    if (!drawer) return;
    if (drawer.hidden) {
      drawerLast = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('is-locked');
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    }
    var close = drawer.querySelector('.ofx-drawer__close');
    if (close) close.focus();
  }
  function drawerClose() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(function () { drawer.hidden = true; }, 280);
    if (drawerLast && drawerLast.focus) drawerLast.focus();
  }
  function drawerStatus(msg) {
    var el = drawer && drawer.querySelector('[data-ofx-drawer-status]');
    if (el) el.textContent = msg || '';
  }
  function drawerSwap(sections, focusSel) {
    if (!drawer || !sections || !sections[SECTION]) return;
    var doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
    var fresh = doc.querySelector('[data-ofx-drawer-inner]');
    var current = drawer.querySelector('[data-ofx-drawer-inner]');
    if (!fresh || !current) return;
    var scroll = current.querySelector('.ofx-drawer__scroll');
    var top = scroll ? scroll.scrollTop : 0;
    current.replaceWith(fresh);
    var nextScroll = fresh.querySelector('.ofx-drawer__scroll');
    if (nextScroll) nextScroll.scrollTop = top;
    var count = fresh.getAttribute('data-count');
    document.querySelectorAll('[data-ofx-cart-count]').forEach(function (c) {
      var changed = c.textContent !== count;
      c.textContent = count;
      if (changed && !reduceMotion) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
    });
    var target = focusSel ? fresh.querySelector(focusSel) : null;
    (target || fresh.querySelector('.ofx-drawer__close')).focus();
  }

  /* Le maillot s'envole vers « Panier » quand on l'ajoute */
  function flyToCart(form) {
    if (reduceMotion || !document.body.animate) return false;
    var scope = form.closest('[data-ofx-product]');
    var shotEl = scope && scope.querySelector('[data-ofx-shot]');
    var src = shotEl
      ? shotEl.querySelector(shotEl.classList.contains('is-back') ? '.ofx-shot__face--back' : '.ofx-shot__face--front')
      : scope && scope.querySelector('[data-ofx-stage] .ofx-art__flip, [data-ofx-stage] .ofx-art__img');
    var cartLink = document.querySelector('.ofx-bar [data-ofx-cart-open]');
    if (!src || !cartLink) return false;
    var a = src.getBoundingClientRect(), b = cartLink.getBoundingClientRect();
    if (a.width < 20 || a.bottom < 40 || a.top > window.innerHeight - 40) return false;
    var ghost = document.createElement('div');
    ghost.className = 'ofx-fly';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.left = a.left + 'px';
    ghost.style.top = a.top + 'px';
    ghost.style.width = a.width + 'px';
    ghost.style.height = a.height + 'px';
    var clone = src.cloneNode(true);
    clone.removeAttribute('data-ofx-flip');
    if (shotEl) { ghost.style.containerType = 'inline-size'; clone.style.opacity = '1'; clone.style.transform = 'none'; clone.style.transition = 'none'; }
    clone.querySelectorAll('[data-ofx-out-name], [data-ofx-out-number]').forEach(function (el) {
      el.removeAttribute('data-ofx-out-name');
      el.removeAttribute('data-ofx-out-number');
    });
    ghost.appendChild(clone);
    document.body.appendChild(ghost);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var anim = ghost.animate([
      { transform: 'translate(0, 0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + (dx * .3) + 'px, ' + (dy * .3 - 70) + 'px) scale(.62) rotate(-10deg)', opacity: 1, offset: .38 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.05) rotate(18deg)', opacity: .35 }
    ], { duration: 820, easing: 'cubic-bezier(.55, 0, .7, .2)', fill: 'forwards' });
    var clean = function () { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); };
    anim.onfinish = clean;
    setTimeout(clean, 1400);
    return true;
  }

  if (drawer) {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ofx-cart-open]');
      if (opener) { e.preventDefault(); drawerOpen(); return; }
      if (e.target.closest('[data-ofx-drawer-close]')) { drawerClose(); return; }
      var line = e.target.closest('[data-ofx-line]');
      if (line && drawer.contains(line)) {
        var key = line.getAttribute('data-ofx-line');
        var q = Math.max(0, Number(line.getAttribute('data-qty')));
        var focusSel = q > 0 ? '[data-ofx-line="' + key + '"][data-qty="' + (line.textContent.trim() === '+' ? q + 1 : q - 1) + '"]' : null;
        line.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: q, sections: [SECTION], sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { line.disabled = false; drawerStatus(res.j.description || res.j.message || 'Mise à jour impossible.'); return; }
            drawerSwap(res.j.sections, focusSel);
          })
          .catch(function () { line.disabled = false; drawerStatus('Connexion interrompue. Réessayez.'); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { drawerClose(); return; }
      if (e.key === 'Tab') {
        var items = drawer.querySelectorAll('a[href], button:not([disabled]), select, input:not([type="hidden"])');
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (e.defaultPrevented || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
      var data = new FormData(form);
      data.append('sections', SECTION);
      data.append('sections_url', window.location.pathname);
      var err = form.querySelector('[data-ofx-form-error]') || (form.closest('[data-ofx-product]') || document).querySelector('[data-ofx-form-error]');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          if (!res.ok) {
            var msg = res.j.description || res.j.message || 'Ajout impossible.';
            if (err && !drawer.contains(form)) { err.hidden = false; err.textContent = msg; }
            else { drawerStatus(msg); }
            return;
          }
          if (err) err.hidden = true;
          var wasOpen = !drawer.hidden;
          var show = function () {
            drawerSwap(res.j.sections);
            drawerOpen();
            drawerStatus(wasOpen ? 'Ajouté au panier.' : '');
          };
          if (!wasOpen && flyToCart(form)) setTimeout(show, 640); else show();
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          form.submit();
        });
    });
  }
})();
